export default `
  {
   reportedArticlesCount { 
      count
      countDB
    }
  }
`;